import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import CustomButton from "@/components/common/Button";
import { notify } from "@/components/common/Notification";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Tabs } from "antd";
import { Save } from "lucide-react";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HRMSNavigationRoutes from "../../utils/navigationRoutes";

const LeaveFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const isEditMode = !!id;

  const schemaleaveapplication = "Hrms Leave application";
  const schemaholiday = "Hrms Holiday";
  const schemacompensatoryleaverequest = "Hrms Compensatory Leave Request";
  const schemahrmsleavetype = "Hrms Leave Type";
  const schemahrmsleavepolicy = "Leave Type Hrms";
  const schemahrmsleaveallocation = "Leave Allocation Hrms";
  const schemahrmsleaveperiod = "Hrms Leave period";
  const schemahrmsleaveencashment = "Encashment Leave";

  const formLeaveApplication = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formHoliday = useMemo(() => createForm({ validateFirst: true }), []);
  const formCompensatoryLeaveRequest = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formLeaveType = useMemo(() => createForm({ validateFirst: true }), []);
  const formLeavePolicy = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formLeaveAllocation = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formLeavePeriod = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );
  const formLeaveEncashment = useMemo(
    () => createForm({ validateFirst: true }),
    []
  );

  const formLeaveApplicationRef = useRef<{ handleSave: () => Promise<any> }>(
    null
  );
  const formHolidayRef = useRef<{ handleSave: () => Promise<any> }>(null);
  const formCompensatoryLeaveRequestRef = useRef<{
    handleSave: () => Promise<any>;
  }>(null);
  const formLeaveTypeRef = useRef<{ handleSave: () => Promise<any> }>(null);
  const formLeavePolicyRef = useRef<{ handleSave: () => Promise<any> }>(null);
  const formLeaveAllocationRef = useRef<{ handleSave: () => Promise<any> }>(
    null
  );
  const formLeavePeriodRef = useRef<{ handleSave: () => Promise<any> }>(null);
  const formLeaveEncashmentRef = useRef<{ handleSave: () => Promise<any> }>(
    null
  );
  if (isEditMode) {
    formLeaveApplication.setInitialValues({ leave_id: id });
    formHoliday.setInitialValues({ leave_id: id });
    formCompensatoryLeaveRequest.setInitialValues({ leave_id: id });
    formLeaveType.setInitialValues({ leave_id: id });
    formLeavePolicy.setInitialValues({ leave_id: id });
    formLeaveAllocation.setInitialValues({ leave_id: id });
    formLeavePeriod.setInitialValues({ leave_id: id });
    formLeaveEncashment.setInitialValues({ leave_id: id });
  }
  const handleSaveAndRedirect = async () => {
    try {
      await formLeaveApplicationRef.current?.handleSave();
      await formHolidayRef.current?.handleSave();
      await formCompensatoryLeaveRequestRef.current?.handleSave();
      await formLeaveTypeRef.current?.handleSave();
      await formLeavePolicyRef.current?.handleSave();
      await formLeaveAllocationRef.current?.handleSave();
      await formLeavePeriodRef.current?.handleSave();
      await formLeaveEncashmentRef.current?.handleSave();
      notify.success(
        isEditMode ? "Leave updated successfully" : "Leave added successfully"
      );
      navigate("/hrms" + HRMSNavigationRoutes.LEAVE_LIST);
    } catch (error) {
      notify.error(
        isEditMode ? "Failed to update leave" : "Failed to add leave"
      );
      console.error("Save error:", error);
    }
  };
  return (
    <>
      <PageHeader
        className="custom-page-header"
        title={isEditMode ? "Edit Leave" : "Create Leave"}
        onBack={() => navigate("/hrms" + HRMSNavigationRoutes.LEAVE_LIST)}
        extra={[
          <CustomButton
            key="save"
            type="primary"
            icon={<Save size={16} />}
            onClick={handleSaveAndRedirect}
          >
            {isEditMode ? "Update" : "Save"}
          </CustomButton>,
        ]}
      />

      <Tabs
        style={{ marginTop: 24 }}
        items={[
          {
            key: "1",
            label: "Leave Application",
            children: (
              <SchemaFormAutoSubmit
                form={formLeaveApplication}
                schemaName={schemaleaveapplication}
                recordId={id}
                ref={formLeaveApplicationRef}
              />
            ),
          },
          {
            key: "2",
            label: "Holiday List",
            children: (
              <SchemaFormAutoSubmit
                form={formHoliday}
                schemaName={schemaholiday}
                recordId={id}
                ref={formHolidayRef}
              />
            ),
          },
          {
            key: "3",
            label: "Compensatory Leave Request",
            children: (
              <SchemaFormAutoSubmit
                form={formCompensatoryLeaveRequest}
                schemaName={schemacompensatoryleaverequest}
                recordId={id}
                ref={formCompensatoryLeaveRequestRef}
              />
            ),
          },
          {
            key: "4",
            label: "Leave Type",
            children: (
              <SchemaFormAutoSubmit
                form={formLeaveType}
                schemaName={schemahrmsleavetype}
                recordId={id}
                ref={formLeaveTypeRef}
              />
            ),
          },
          {
            key: "5",
            label: "Leave policy",
            children: (
              <SchemaFormAutoSubmit
                form={formLeaveType}
                schemaName={schemahrmsleavepolicy}
                recordId={id}
                ref={formLeaveTypeRef}
              />
            ),
          },
          {
            key: "6",
            label: "Leave allocation",
            children: (
              <SchemaFormAutoSubmit
                form={formLeaveType}
                schemaName={schemahrmsleaveallocation}
                recordId={id}
                ref={formLeaveTypeRef}
              />
            ),
          },

          {
            key: "7",
            label: "Leave Encashment",
            children: (
              <SchemaFormAutoSubmit
                form={formLeaveType}
                schemaName={schemahrmsleaveencashment}
                recordId={id}
                ref={formLeaveTypeRef}
              />
            ),
          },
          {
            key: "8",
            label: "Leave Period",
            children: (
              <SchemaFormAutoSubmit
                form={formLeaveType}
                schemaName={schemahrmsleaveperiod}
                recordId={id}
                ref={formLeaveTypeRef}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default LeaveFormPage;
